import { Severity } from "@cayo/shared/api/types/cayo-graph";
import { showMessage } from "@cayo/shared/components/App/utils/showMessage";

export const showError = (err: string | undefined, severity?: Severity | undefined) => {
  // appEvents.trigger({ showError: err });

  showMessage(err ?? "", severity ?? "error");
};
